import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Opportunity } from './components/Opportunity';
import { FuturePacing } from './components/FuturePacing';
import { Story } from './components/Story';
import { Proof } from './components/Proof';
import { Testimonials } from './components/Testimonials';
import { VideoExamples } from './components/VideoExamples';
import { ProductBreakdown } from './components/ProductBreakdown';
import { Guarantee } from './components/Guarantee';
import { Urgency } from './components/Urgency';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SalesNotification } from './components/SalesNotification';
export function App() {
  return <div className="w-full min-h-screen bg-gradient-to-b from-slate-900 via-purple-900 to-slate-900" data-id="element-0">
      <SalesNotification data-id="element-1" />
      <Hero data-id="element-2" />
      <Problem data-id="element-3" />
      <Opportunity data-id="element-4" />
      <FuturePacing data-id="element-5" />
      <Story data-id="element-6" />
      <Proof data-id="element-7" />
      <Testimonials data-id="element-8" />
      <VideoExamples data-id="element-9" />
      <ProductBreakdown data-id="element-10" />
      <Guarantee data-id="element-11" />
      <Urgency data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}